import { Spinner } from "react-bootstrap";

function AssessmentLoading() {
  return (
    <div className="d-flex justify-content-center" style={{ height: "100vh", marginTop: "15%" }}>
      <Spinner variant="dark" animation="border" style={{ height: "50px", width: "50px" }}>
        <output className="visually-hidden" role="alert">
          Loading
        </output>
      </Spinner>
    </div>
  );
}

export default AssessmentLoading;
